export default "__VITE_ASSET__vLMw$_q$__"